"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCard = exports.SpringboardUserPrefill = void 0;
var react_1 = __importDefault(require("react"));
var pages_common_1 = require("@qwilr/pages-common");
var PrefillContextProvider_1 = require("./PrefillContextProvider");
var UserAvatar_1 = require("@CommonFrontend/Public/Springboard/UserAvatar");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./UserPrefill.css"));
var AuthenticationContext_1 = require("@CommonFrontend/Public/Identity/AuthenticationContext");
var Esignature_1 = require("@CommonFrontendBackend/Accept/Esignature");
var SpringboardUserPrefill = function () {
    var prefill = (0, PrefillContextProvider_1.usePrefillContext)().prefill;
    var user = (0, pages_common_1.useAuthenticationContext)().user;
    if (!user || !prefill) {
        return null;
    }
    return (react_1.default.createElement(exports.UserCard, { name: prefill.legalName, email: prefill.email, organisation: prefill.organisation, profileImageUrl: user.profileImageUrl, signature: prefill.signature }));
};
exports.SpringboardUserPrefill = SpringboardUserPrefill;
var UserCard = function (_a) {
    var _b = _a.profileImageUrl, profileImageUrl = _b === void 0 ? "" : _b, name = _a.name, email = _a.email, organisation = _a.organisation, signature = _a.signature;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.card },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", direction: "vertical", padding: "l" },
            !!signature && (react_1.default.createElement("div", { className: styles.signatureContainer },
                react_1.default.createElement("div", { className: styles.signatureHeader },
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "E-Signature"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, new Date(Date.now()).toLocaleDateString())),
                react_1.default.createElement("img", { src: (0, Esignature_1.esignatureDataToDataUrl)(signature), alt: "Your saved e-signature" }))),
            react_1.default.createElement("div", { className: styles.userDetailsContainer },
                react_1.default.createElement(UserAvatar_1.UserAvatar, { url: profileImageUrl, name: name ? name : email, size: "large" }),
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", direction: "vertical", className: styles.userDetails, justify: "center" },
                    !!name && (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m", lineHeight: "compact" }, name)),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", lineHeight: "compact" }, email)),
                react_1.default.createElement(ActionsMenu, null)),
            !!organisation && (react_1.default.createElement("div", { className: styles.organisationContainer },
                react_1.default.createElement("span", { className: styles.organisationIcon },
                    react_1.default.createElement(icons_1.Account, null)),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", lineHeight: "compact", strong: true },
                    "Organization: ",
                    organisation))))));
};
exports.UserCard = UserCard;
var OptionMenuItemWithIcon = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, label = _a.label;
    return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: onClick },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
            react_1.default.createElement("div", { className: styles.optionMenuItemIcon }, icon),
            react_1.default.createElement("div", { className: styles.optionMenuItemText }, label))));
};
var ActionsMenu = function () {
    var _a = (0, PrefillContextProvider_1.usePrefillContext)(), removeField = _a.removeField, prefill = _a.prefill, acceptTelemetry = _a.acceptTelemetry;
    var signOut = (0, pages_common_1.useAuthenticationContext)().signOut;
    var getAuthUrl = (0, AuthenticationContext_1.useAuthenticationContext)().getAuthUrl;
    var pageUrl = window.location.href;
    var loginUrl = getAuthUrl("login", pageUrl, AuthenticationContext_1.AuthenticationOrigin.AcceptPrefill);
    var hasSignature = !!(prefill === null || prefill === void 0 ? void 0 : prefill.signature);
    var hasName = !!(prefill === null || prefill === void 0 ? void 0 : prefill.legalName);
    var hasOrganisation = !!(prefill === null || prefill === void 0 ? void 0 : prefill.organisation);
    var profileEditedTelemetry = function (type) {
        return acceptTelemetry.track("Edit Springboard Profile", { edit_type: type });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(kaleidoscope_1.OptionMenu, { autoStack: true, button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null) }) },
            hasName && (react_1.default.createElement(OptionMenuItemWithIcon, { icon: react_1.default.createElement(icons_1.Edit, null), label: "Edit name", onClick: function () {
                    profileEditedTelemetry("name");
                    removeField("legalName");
                } })),
            hasSignature && (react_1.default.createElement(OptionMenuItemWithIcon, { icon: react_1.default.createElement(icons_1.Esignature, null), label: "Edit signature", onClick: function () {
                    profileEditedTelemetry("signature");
                    removeField("signature");
                } })),
            hasOrganisation && (react_1.default.createElement(OptionMenuItemWithIcon, { icon: react_1.default.createElement(icons_1.Account, null), label: "Edit organization", onClick: function () {
                    profileEditedTelemetry("organisation");
                    removeField("organisation");
                } })),
            react_1.default.createElement(OptionMenuItemWithIcon, { icon: react_1.default.createElement(icons_1.User, null), label: "Switch account", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, signOut()];
                            case 1:
                                _a.sent();
                                window.location.href = loginUrl;
                                return [2];
                        }
                    });
                }); } }),
            react_1.default.createElement(OptionMenuItemWithIcon, { icon: react_1.default.createElement(icons_1.Logout, null), label: "Log out", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, signOut()];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                }); } }))));
};
